import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { store } from './data/store'
import { router } from './routes'
import axios from 'axios'

Vue.config.productionTip = false

axios.defaults.baseURL = "https://sigef.cloudsenactpi.net/"
//axios.defaults.baseURL = "http://localhost/sigef/public/"
axios.defaults.withCredentials = true

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
